const BaseColors = {
  rolfPink: '#FF9EB5',
	rolfYellow: '#FFE061',
	rolfGreen: '#82E5D6',
	rolfBlue: '#36ABF0',
	rolfPurple: '#5747AB',

	rolfPinkLight: '#FFD4DE',
	rolfYellowLight: '#FFF5CF',
	rolfGreenLight: '#CFF5F0',
	rolfBlueLight: '#C2E5FA',
	rolfpurpleLight: '#DDDBEF',

	rolfPinkDark: '#47263D',
	rolfYellowDark: '#402E00',
	rolfGreenDark: '#213836',
	rolfBlueDark: '#0F2140',
	rolfPurpleDark: '#2B2456',

	rolfTagPositive: '#64E3B2',
	rolfTagNegative: '#FF5C5C'
}

export default BaseColors